module.exports = __webpack_public_path__ + "img/sunny-icon.9a186f80.jpg";